import { TakingQuizController } from './taking-quiz.controller';
import { TakingQuizProps } from './taking-quiz.model';

const TakingQuiz = (props: TakingQuizProps) => {
  return <TakingQuizController {...props} />;
};

export default TakingQuiz;
